<template>
    <div class="forget">
        <div class="forget-top content-bag">
            <div class="Register-content content-within">
                <div class="Register-form content-formter">
                    <div class="Register-img"></div>
                    <div class="tall-input">
                        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
                            <el-form-item prop="mobile">
                                <i class="icon-user"></i>
                                <el-input v-model="ruleForm.mobile" placeholder="电话"></el-input>
                            </el-form-item>
                            <el-form-item prop="captcha">
                                <i class="icon-user"></i>
                                <el-input
                                    v-model="ruleForm.captcha"
                                    class="Verification"
                                    placeholder="验证码"
                                    readonly autocomplete="off" onMouseDown="this.removeAttribute('readonly')"
                                ></el-input>
                                <div class="Vderification" @click="sendVerify">{{ second === totalSecond ? '获取验证码' : second + '秒后发送' }}</div>
                            </el-form-item>
                            <el-form-item prop="pass">
                                <i class="icon-user"></i>
                                <el-input
                                    v-if="visible"
                                    type="password"
                                    v-model="ruleForm.pass"
                                    autocompleted="off"
                                    placeholder="请输入新密码"
                                >
                                    <i slot="suffix" title="显示密码" 
                                        class="iconfont icon-yanjingbi"
                                        style="cursor:pointer;margin-right:5px"
                                        @click="changePass('show')"
                                    ></i>
                                </el-input>
                                <el-input
                                    v-else
                                    type="text"
                                    v-model="ruleForm.pass"
                                    autocompleted="off"
                                    placeholder="请输入新密码"
                                >
                                    <i slot="suffix" title="隐藏密码" 
                                        class="iconfont icon-yanjing"
                                        style="cursor:pointer;margin-right:5px"
                                        @click="changePass('hide')"
                                    ></i>
                                </el-input>
                            </el-form-item>
                            <el-form-item prop="pass">
                                <i class="icon-user"></i>
                                <el-input
                                    v-if="visible1"
                                    type="password"
                                    v-model="ruleForm.checkPass"
                                    placeholder="请确认新密码"
                                >
                                    <i slot="suffix" title="显示密码"
                                        class="iconfont icon-yanjingbi"
                                        style="cursor:pointer;margin-right:5px"
                                        @click="changePass1('show')"
                                    ></i>
                                </el-input>
                                <el-input
                                    v-else
                                    type="text"
                                    v-model="ruleForm.checkPass"
                                    placeholder="请确认新密码"
                                >
                                    <i slot="suffix" title="隐藏密码"
                                        class="iconfont icon-yanjing"
                                        style="cursor:pointer;margin-right:5px"
                                        @click="changePass1('hide')"
                                    ></i>
                                </el-input>
                            </el-form-item>
                        </el-form>
                        <!-- 登录 -->
                        <div class="el-form-item" style="margin-bottom: 22px;">
                            <div class="el-form-item__content" @click="submitForm('ruleForm')">
                                <div class="el-button is-center el-button--primary">重置密码</div>
                            </div>
                        </div>
                        <!-- 注册 -->
                        <div class="el-form-item" style="margin-bottom: 22px;">
                            <div class="el-form-item__content">
                                <span>已有账号？</span>
                                <router-link to="/">立即登录</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 底部 -->
        <Lrheder class="header"></Lrheder>
    </div>
</template>

<script>
import md5 from "md5";
import Lrheder from "./Lrheader";
import { ajaxPost, Baseurl } from "../../api/api/api";

export default {
    name: "forget",
    data() {
        var mobile = (rule, value, callback) => {
            var ymobile = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
            if (!value) {
                callback(new Error("请输入手机号"));
            } else if (!ymobile.test(value)) {
                callback(new Error("手机号格式不正确"));
            } else {
                callback();
            }
        };
        var validatePass = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入密码"));
            } else {
                if (this.ruleForm.checkPass !== "") {
                    this.$refs.ruleForm.validateField("checkPass");
                }
                callback();
            }
        };
        return {
			visible: true,
            visible1: true,
            totalSecond: 60, // 总秒数
            second: 60, // 当前秒数
            timer: null, // 定时器 id
            ruleForm: {
                mobile: "",
                captcha: "",
                pass: "",
                checkPass: "",
            },
            rules: {
                mobile: [
                    { required: true, message: "请输入手机号", trigger: "blur" },
                    { validator: mobile, trigger: "blur" },
                ],
                captcha: [{ required: true, message: "请输入验证码", trigger: "blur" }],
                pass: [{ required: true, validator: validatePass, trigger: "blur" }],
            },
        };
    },
    components: {
        Lrheder,
    },
    methods: {
		changePass(value) {
			this.visible = !(value === 'show')
		},
        changePass1(value) {
            this.visible1 = !(value === 'show')
        },
        sendVerify() {
            var reg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
            if (this.ruleForm.mobile === "") {
                this.$message.error("请输入手机号");
            } else if (!reg.test(this.ruleForm.mobile)) {
                this.$message.error("手机号格式不正确");
            } else {
                // this.time = 60;
                // this.disabled = true;
                // this.timer();
                if (!this.timer && this.second === this.totalSecond) {
                    // 开启倒计时
                    this.timer = setInterval(() => {
                        this.second--
                        if (this.second <= 0) {
                            clearInterval(this.timer) // 清除定时器
                            this.timer = null // 重置定时器 id
                            this.second = this.totalSecond // 归位
                        }
                    }, 1000)
                    ajaxPost(Baseurl + 'userControllers/getCode', {
                        telephone: this.ruleForm.mobile,
                    }).then((res) => {
                        // console.log(res);
                        if (res.data.code == 200) {
                            this.recCap = res.data.data
                        }
                    })
                }
                // this.$http
                //     .post(Baseurl + "userControllers/getCode", {
                //         telephone: this.ruleForm.mobile,
                //     })
                //     .then(res => {
                //         if (res.data.code === 200) {
                //             this.recCap = res.data.data;
                //         }
                //     });
            }
        },
        // timer() {
        //     if (this.time > 0) {
        //         this.time--;
        //         this.btnText = this.time + "s后";
        //         setTimeout(this.timer, 1000);
        //     } else {
        //         this.time = 0;
        //         this.btnText = "发送验证码";
        //         this.disabled = false;
        //     }
        // },
        submitForm(ruleForm) {
            this.$refs[ruleForm].validate(valid => {
                if (valid) {
                    if (md5(this.ruleForm.captcha) != this.recCap) {
                        this.$message.error("验证码输入错误");
                    } else if (this.ruleForm.pass !== this.ruleForm.checkPass) {
                        this.$message.error("两次密码输入不一致");
                    } else {
                        const loading = this.$loading({
                            lock: true,
                            text: 'Loading',
                            spinner: 'el-icon-loading',
                            background: 'rgba(255, 255, 255, 0.7)'
                        });
                        const paramsData = {
                            telephone: this.ruleForm.mobile,
                            newPassword: this.ruleForm.pass,
                            cfgPassword: this.ruleForm.checkPass,
                            code: this.ruleForm.captcha,
                        };
                        ajaxPost(Baseurl + "userControllers/forgetPassword", paramsData).then(res => {
                            loading.close();
                            if (res.data.code === 200) {
                                this.$router.push("/");
                            }
                        });
                    }
                }
            });
        },
    },
    destroyed() {
        clearInterval(this.timer)
    }
};
</script>

<style lang="scss">
.forget {
    .el-form-item__label {
        text-align: left;
    }
    width: 100%;
    height: 100%;
    display: block;
    .tall-input {
        margin: 20px 30px;
        .el-form-item__content {
            line-height: 40px;
            position: relative;
            font-size: 14px;
            .right {
                float: right;
            }
            a {
                color: #003488;
                text-decoration: underline;
                cursor: pointer;
            }
            .is-center {
                width: 100%;
                letter-spacing: 2px;
            }
            .el-button--primary {
                width: 100%;
                color: #fff;
                background-color: #194f7b;
                border-color: #194f7b;
            }
        }
    }
    .Verification {
        float: left;
        width: 65%;
    }
    .Vderification {
        background-color: #194f7b;
        float: right;
        width: 25%;
        text-align: center;
        padding: 0 10px;
        border-radius: 4px;
        color: #fff;
    }
}
</style>
